import type { StateCreator } from "zustand"
import { create } from "@/app/state"
import type { SetDeck } from "@/services/api/flashcards/get-all"

interface RenameFlashcardModalState {
  isOpen: boolean
  flashcardToRename: SetDeck | null
  openModal: (flashcard: SetDeck) => void
  closeModal: () => void
}

const state: StateCreator<RenameFlashcardModalState> = (set) => ({
  isOpen: false,
  flashcardToRename: null,
  openModal: (flashcard: SetDeck) => set({ isOpen: true, flashcardToRename: flashcard }),
  closeModal: () => set({ isOpen: false, flashcardToRename: null }),
})

export const useRenameFlashcardModal = create<RenameFlashcardModalState>()(state)
